import { render, staticRenderFns } from "./DisplayResult.vue?vue&type=template&id=4da82fd0&"
import script from "./DisplayResult.vue?vue&type=script&lang=js&"
export * from "./DisplayResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports